import { OptionItem } from "@transfr-inc/dashboard-components/forms";

export class LessonOptionItem extends OptionItem {
  constructor(lesson) {
    const { index, title, orderNumber } = lesson;
    const displayText = orderNumber ? `Lesson ${orderNumber}: ${title}` : title;
    super({ id: index + title, text: displayText, data: lesson });
  }
}
